<template>
  <footer class="copyright">COPYRIGHT © ENDORFINE.FR - 2019</footer>
</template>

<script>
export default {
  name: 'copyright',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Template_Copyright.vue